<div class="chart-wrapper">
    <canvas baseChart
        [datasets]="pieChartData"
        [labels]="pieChartLabels"
        [type]="pieChartType"
        [options]="pieChartOptions"
        [plugins]="pieChartPlugins"
        [legend]="pieChartLegend">
    </canvas>
</div>